import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../lib/firebase';

export interface PricingTrackingData {
  sessionId: string;
  userId: string;
  timestamp: Date;
  
  // Temps avant premier clic
  timeToFirstClick: number | null;
  
  // Hésitations
  averageHesitation: number;
  maxHesitation: number;
  
  // Rage clicks
  rageClicksCount: number;
  
  // Dead clicks
  deadClicksCount: number;
  deadClicks: Array<{
    target: string;
    timestamp: number;
    x: number;
    y: number;
  }>;
  
  // Scroll
  maxScrollDepth: number;
  averageScrollSpeed: number;
  scrollBackwardsCount: number;
  
  // Hovers sur CTA
  ctaHoversCount: number;
  ctaHoversDurations: Array<{
    element: string;
    duration: number;
    timestamp: number;
  }>;
  
  // Interactions
  toggleClicksCount: number;
  tooltipOpensCount: number;
  faqOpensCount: number;
  faqQuestions: string[];
  planComparisonsCount: number;
  textCopyAttemptsCount: number;
  
  // Statistiques générales
  totalClicks: number;
  totalMouseMoves: number;
  sessionDuration: number;
  
  // Tracking des cookies affiliés
  hasAffiliateCookie: boolean;
  affiliateId?: string;
  affiliateName?: string;
  affiliateCode?: string;
}

class PricingTrackingService {
  private collectionName = 'pricingTracking';

  async saveTrackingData(data: PricingTrackingData): Promise<void> {
    try {
      // Filtrer les valeurs undefined car Firestore ne les accepte pas
      const cleanData = Object.fromEntries(
        Object.entries(data).filter(([_, value]) => value !== undefined)
      );
      
      await addDoc(collection(db, this.collectionName), {
        ...cleanData,
        timestamp: serverTimestamp(),
      });
      
      // console.log supprimé
    } catch (error) {
      // console.error supprimé
    }
  }

  // Méthode pour sauvegarder un événement spécifique en temps réel
  async saveEvent(
    userId: string,
    sessionId: string,
    eventType: string,
    eventData: any
  ): Promise<void> {
    try {
      await addDoc(collection(db, `${this.collectionName}Events`), {
        userId,
        sessionId,
        eventType,
        eventData,
        timestamp: serverTimestamp(),
      });
    } catch (error) {
      // console.error supprimé
    }
  }
}

export const pricingTrackingService = new PricingTrackingService();

